import logo from "./logo.svg";
import "./App.css";
import Navbar from "./components/Navbar";
import AboutUs from "./Pages/AboutUs";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  BrowserRouter,
} from "react-router-dom";
import { Link } from "react-router-dom";
import Home from "./Pages/Home";
import Services from "./Pages/Services";
import Projects from "./Pages/Projects";
import Footer from "./components/Footer";
import Scroll from "./components/Scroll";
import Drawer from "./Pages/Drawer";


function App() {
  return (

    <BrowserRouter>
      <div className=" ">
      
        <Navbar />
      </div>
      
      <Routes>
       
          <Route path="/" element={<Home/>} />
          <Route path="about" element={<AboutUs/>} />
        <Route path="services" element={<Services />} />
        <Route path="projects" element={<Projects/>} />
        <Route path="drawer" element={<Drawer/>} />
        </Routes>
       
      <Footer/>
    </BrowserRouter>)
    
}

export default App;
